import Vue from 'vue'
import fa from "element-ui/src/locale/lang/fa";
import router from "../router";

// 格式化时间到秒
window.timestampToTime = Vue.prototype.timestampToTime = function (time, type) {
  var date = new Date(time);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  // alert(date)
  var Y = date.getFullYear();
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
  var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
  var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  if (type == 'Y:M:D-h:m:s') {
    return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s;
  } else if (type == 'Y:M:D') {
    return Y + '-' + M + '-' + D;
  } else if (type == 'Y:M') {
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    return Y + '-' + M;
  } else if (type == 'D') {
    return D;
  } else if (type == 'h:m:s') {
    return h + ':' + m + ':' + s;
  } else if (type == 'M') {
    return (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  } else if (type == 'Y:M:D-h:m') {
    return Y + '-' + M + '-' + D + ' ' + h + ':' + m;
  }
}





// WEBPACK FOOTER //
// ./src/utils/common.js